<div class="grid">
  <div class="col-10">
    <form
      [formGroup]="companyForm"
      (ngSubmit)="submitForm()"
      id="container-form"
    >
      <h2 class="mb-0">Información de la empresa</h2>
      <p>{{ selectedRol }}</p>

      <div class="grid mt-1">
        <div class="custom-input col-12 md:col-12 lg:col-12 flex flex-column">
          <label for="razon_social">Razón social/Apellido y nombre *</label>
          <input
            pInputText
            id="razon_social"
            aria-describedby="razon-social-help"
            placeholder="Ingrese razón social"
            formControlName="razon_social"
            maxlength="100"
            [readonly]="isCompany"
            [ngClass]="{
              'ng-invalid ng-dirty': hasErrors('razon_social', 'required'),
              disabled: isCompany
            }"
          />
          <div
            class="text-danger p-error"
            *ngIf="hasErrors('razon_social', 'required')"
          >
            Este campo es obligatorio
          </div>
        </div>
      </div>

      <div class="grid mt-1">
        <div class="custom-input col-12 md:col-12 lg:col-6 flex flex-column">
          <label for="cuit">CUIT *</label>
          <p-inputMask
            mask="99-99999999-9"
            placeholder="99-99999999-9"
            formControlName="cuit"
            [readonly]="isCompany"
            [ngClass]="{
              'ng-invalid ng-dirty': hasErrors('cuit', 'required'),
            }"
            [style]="
              isCompany
                ? {
                    'background-color': 'rgb(223, 223, 223)',
                    border: 'none',
                    'box-shadow': 'none'
                  }
                : {}
            "
          ></p-inputMask>
          <div
            class="text-danger p-error"
            *ngIf="hasErrors('cuit', 'required')"
          >
            Este campo es obligatorio
          </div>
        </div>

        <div class="custom-input col-12 md:col-12 lg:col-6 flex flex-column">
          <label for="phone">Teléfono *</label>
          <input
            pInputText
            id="phone"
            aria-describedby="phone-company-help"
            placeholder="Ingrese teléfono"
            formControlName="phone"
            maxlength="15"
            [readonly]="isCompany"
            [ngClass]="{
              'ng-invalid ng-dirty':
                hasErrors('phone', 'maxlength') ||
                hasErrors('phone', 'pattern'),
              disabled: isCompany
            }"
          />
          <div
            class="text-danger p-error"
            *ngIf="hasErrors('phone', 'minlength')"
          >
            Este campo no puede poseer menos de 9 caracteres
          </div>
          <div
            class="text-danger p-error"
            *ngIf="hasErrors('phone', 'maxlength')"
          >
            Este campo no puede poseer más de 15 caracteres
          </div>
          <div
            class="text-danger p-error"
            *ngIf="hasErrors('phone', 'pattern')"
          >
            El campo solo acepta números. Las letras no son permitidas.
          </div>
        </div>
      </div>

      <div class="grid mt-1">
        <div class="custom-input col-12 md:col-6 lg:col-6 flex flex-column">
          <label for="province">Provincia *</label>

          <input
            *ngIf="isCompany"
            pInputText
            id="province_display"
            formControlName="province"
            readonly="true"
            class="disabled"
          />

          <p-dropdown
            *ngIf="!isCompany"
            [options]="provinces"
            optionLabel="name"
            optionValue="name"
            formControlName="province"
            placeholder="Seleccione una provincia"
            [ngClass]="{
              'ng-invalid ng-dirty': hasErrors('province', 'required')
            }"
          ></p-dropdown>

          <div
            class="text-danger p-error"
            *ngIf="hasErrors('province', 'required')"
          >
            Este campo es obligatorio
          </div>
        </div>

        <div class="custom-input col-12 md:col-6 lg:col-6 flex flex-column">
          <label for="city">Localidad *</label>

          <input
            *ngIf="isCompany"
            pInputText
            id="city_display"
            formControlName="city"
            readonly="true"
            class="disabled"
          />

          <p-dropdown
            *ngIf="!isCompany"
            [options]="localities"
            formControlName="city"
            optionLabel="name"
            optionValue="name"
            placeholder="Seleccione su localidad"
            [ngClass]="{
              'ng-invalid ng-dirty': hasErrors('city', 'required')
            }"
          ></p-dropdown>

          <div
            class="text-danger p-error"
            *ngIf="hasErrors('city', 'required')"
          >
            Este campo es obligatorio
          </div>
        </div>
      </div>

      <div class="grid mt-1">
        <div class="custom-input col-12 md:col-6 lg:col-6 flex flex-column">
          <label for="street">Calle *</label>
          <input
            pInputText
            maxlength="50"
            id="street"
            placeholder="Ingrese calle"
            formControlName="street"
            [readonly]="isCompany"
            [ngClass]="{
              'ng-invalid ng-dirty': hasErrors('street', 'required'),
              disabled: isCompany
            }"
          />
          <div
            class="text-danger p-error"
            *ngIf="hasErrors('street', 'required')"
          >
            Este campo es obligatorio
          </div>
        </div>

        <div class="custom-input col-12 md:col-6 lg:col-6 flex flex-column">
          <label for="number">Número *</label>
          <input
            maxlength="5"
            pInputText
            id="number"
            type="text"
            placeholder="Ingrese número"
            formControlName="number"
            [readonly]="isCompany"
            [ngClass]="{
              'ng-invalid ng-dirty':
                hasErrors('number', 'required') ||
                hasErrors('number', 'pattern'),
              disabled: isCompany
            }"
          />
          <div
            class="text-danger p-error"
            *ngIf="hasErrors('number', 'required')"
          >
            Este campo es obligatorio
          </div>
          <div
            class="text-danger p-error"
            *ngIf="hasErrors('number', 'pattern')"
          >
            El campo solo acepta números.
          </div>
        </div>
      </div>

      <div class="grid mt-1">
        <div class="custom-input col-12 md:col-6 lg:col-6 flex flex-column">
          <label for="neighborhood">Barrio</label>
          <input
            pInputText
            id="neighborhood"
            placeholder="Ingrese barrio"
            formControlName="neighborhood"
            [readonly]="isCompany"
            [ngClass]="{
              disabled: isCompany
            }"
          />
        </div>

        <div class="custom-input col-12 md:col-6 lg:col-6 flex flex-column">
          <label for="postal_code">Código Postal *</label>
          <input
            maxlength="10"
            minlength="4"
            pInputText
            id="postal_code"
            type="text"
            placeholder="Ingrese código postal"
            formControlName="postal_code"
            [readonly]="isCompany"
            [ngClass]="{
              'ng-invalid ng-dirty':
                hasErrors('postal_code', 'required') ||
                hasErrors('claimedNameLastNameOrBusinessName', 'pattern'),
              disabled: isCompany
            }"
          />
          <div
            class="text-danger p-error"
            *ngIf="hasErrors('postal_code', 'required')"
          >
            Este campo es obligatorio
          </div>
        </div>
      </div>

      <div class="grid mt-1">
        <div class="custom-input col-12 md:col-6 lg:col-6 flex flex-column">
          <label for="tower">Torre</label>
          <input
            maxlength="30"
            pInputText
            id="tower"
            placeholder="Ingrese torre"
            formControlName="tower"
            [readonly]="isCompany"
            [ngClass]="{
              disabled: isCompany
            }"
          />
        </div>

        <div class="custom-input col-12 md:col-6 lg:col-6 flex flex-column">
          <label for="floor_apartment">Piso/Departamento</label>
          <input
            maxlength="10"
            pInputText
            id="floor_apartment"
            placeholder="Ingrese piso/depto"
            formControlName="floor_apartment"
            [readonly]="isCompany"
            [ngClass]="{
              'ng-invalid ng-dirty': hasErrors('phone', 'pattern'),
              disabled: isCompany
            }"
          />
          <div
            class="text-danger p-error"
            *ngIf="hasErrors('floor_apartment', 'maxlength')"
          >
            Este campo no puede poseer más de 10 caracteres
          </div>
        </div>
      </div>

      <div class="grid mt-1">
        <div class="custom-input col-12 md:col-12 lg:col-12 flex flex-column">
          <label for="email">Correo electrónico *</label>
          <input
            pInputText
            id="email"
            type="email"
            placeholder="Ingrese email"
            formControlName="email"
            [readonly]="isCompany"
            [ngClass]="{
              'ng-invalid ng-dirty':
                hasErrors('email', 'required') || hasErrors('email', 'email'),
              disabled: isCompany
            }"
          />
          <div
            class="text-danger p-error"
            *ngIf="hasErrors('email', 'required')"
          >
            Este campo es obligatorio
          </div>
          <div class="text-danger p-error" *ngIf="hasErrors('email', 'email')">
            El formato de email no es válido
          </div>
        </div>
      </div>
      <p
        [ngClass]="{
          'success-card': !isNewCompany,
          'error-card': isNewCompany
        }"
      >
        {{ messageCompany }}
      </p>
      <p-button
        class="nextButton"
        label="Siguiente"
        [disabled]="companyForm.invalid"
        type="submit"
      ></p-button>
      <span class="backLink ml-3"><a (click)="goBack()">Volver</a></span>
    </form>
  </div>
</div>
